<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <!--右侧内容-->
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      <span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>直播
    </div>
    <div class="class_add_con">
        <form data-vv-scope="form">
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tr class="tita">
              <td class="left_td">直播信息</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td class="left_td pt30">直播名称：</td>
              <td class="pt20">
                <input type="text" name="name" id="name" v-model="params.name" v-validate="'required'" v-bind:maxlength="60" placeholder="60字以内" class="put_495"/>
                <div class="error_msg_tip">{{ errors.first('form.name') }}</div>
              </td>
            </tr>
            <tr>
              <td class="left_td pt20" valign="top">直播讲师：</td>
              <td class="pt20">
                <dl class="js_man" v-for="item in teacherList" :key="item.id">
                  <a class="all_del_icon" @click="delTSelectedId(currentTCIds, item.id)"></a>
                  <dt>
                    <img src="@/assets/images/teacher_4.jpg" width="166" height="166" v-if="!item.faceUrl || item.faceUrl == ''" />
                    <img :src="item.faceUrl" v-if="item.faceUrl && item.faceUrl !== ''" width="166" height="166">
                  </dt>
                  <dd>{{item.name}}</dd>
                </dl>
                <div class="clear"></div>
                <p><a href="javascript:void(0);" @click="addTeacher(currentTCIds)" class="add_bt_all">添加讲师</a><br /></p></td>
            </tr>
            <tr>
              <td class="left_td">直播分类：</td>
              <td>
                <select name="select" id="select" class="all_select" v-model="params.type">
                  <option value="123">综合课程</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="left_td pt20" valign="top">直播封面：</td>
              <td class="rdiv pt20">
                <img v-if="params.cover && params.cover!==''" :src="params.cover"  class="upload_img" />
                <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'cover'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS>
                <p class="mt10"><span class="tips_text">建议图片长280px宽150px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
              </td>
            </tr>
            <tr>
              <td class="left_td pt30" valign="top">直播时间：</td>
              <td class="pt20">
                <input type="text" id="J-xl" placeholder="选择开始时间" v-model="params.startTime">
                <input type="text" id="J-xl-2" placeholder="选择结束时间" v-model="params.endTime">
              </td>
            </tr>
            <tr>
              <td class="left_td pt30">直播简介：</td>
              <td class="pt20">
                <textarea name="outline" id="outline" cols="" rows="" class="text_area w490 h70" v-model="params.outline" v-validate="'required'" v-bind:maxlength="200"></textarea>
                <div class="error_msg_tip">{{ errors.first('form.outline') }}</div>
              </td>
            </tr>
            <tr>
              <td class="left_td pt30" valign="top">直播介绍：</td>
              <td valign="top" class="pt30">
                <Ueditor :value="ueditor.value" :config="ueditor.config" ref="ue"></Ueditor>
                <br><br>
              </td>
            </tr>
            <tr class="tita">
              <td class="left_td">直播设置</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td class="left_td " valign="top" style="padding-top:20px;">推送范围(显示到前台"任务"列表中)：</td>
              <td class="pt20" valign="top">
                <input name="see" type="radio" value="2" v-model="params.visibleRange"/>
                全员可见　　
                <input name="see" type="radio" value="1" v-model="params.visibleRange"/>
                指定人员可见　
                <input name="see" type="radio" value="0" v-model="params.visibleRange"/>
                无
                <p class="text_12 only" style="display:none">仅支持本企业全体用户观看</p>
                <!--指定人员-->
                <dl class="qa_man_add" v-if="params.visibleRange == '1'">
                  <dt><a href="javascript:void(0);" @click="showRange" class="on">+选择</a></dt>
                  <dd v-if="publicStateList.length > 0">
                    已选标签{{rangePermission.getPersonTypes(publicStateList).tags}}个,
                    已选用户{{rangePermission.getPersonTypes(publicStateList).users}}个,
                    已选人员{{rangePermission.getPersonTypes(publicStateList).members}}个,
                    已选部门{{rangePermission.getPersonTypes(publicStateList).depts}}个
                    <!--span v-for="item in publicStateList" :key="item.id" style="background: none; height: 36px; line-height: 36px; text-align: center; width: auto; margin-bottom: 0; margin-left: 0;">{{item.name}}</span-->
                  </dd>
                </dl>
                <!--/指定人员-->
              </td>
            </tr>
            <!--<tr>-->
              <!--<td class="left_td " valign="top" style="padding-top:20px;">可见范围：</td>-->
              <!--<td class="pt20" valign="top">-->
                <!--<p>-->
                  <!--<input name="see2" type="radio" value="2" v-model="params.scope"/>-->
                  <!--全员-->
                  <!--<input name="see2" type="radio" value="1" v-model="params.scope"/>-->
                  <!--指定人员-->
                  <!--<input name="see2" type="radio" value="0" v-model="params.scope"/>-->
                  <!--无-->
                <!--</p>-->
                <!--&lt;!&ndash;指定人员&ndash;&gt;-->
                <!--<dl class="qa_man_add" v-if="params.scope == '1'">-->
                  <!--<dt><a href="javascript:void(0);" @click="showScope" class="on">+选择</a></dt>-->
                  <!--<dd v-if="scopeList.length > 0">-->
                    <!--<span v-for="item in scopeList" :key="item.id" style="background: none; height: 36px; line-height: 36px; text-align: center; width: auto; margin-bottom: 0; margin-left: 0;">{{item.name}}</span>-->
                  <!--</dd>-->
                <!--</dl>-->
                <!--&lt;!&ndash;/指定人员&ndash;&gt;</td>-->
            <!--</tr>-->
            <tr class="tita">
              <td class="left_td">其他设置</td>
              <td>&nbsp;</td>
            </tr>
            <tr style="display:none">
              <td class="left_td">学时：</td>
              <td><input name="stime" type="radio" value="0" v-model="stime" @click="changePeriod('0')"/>
                关闭　　
                <input name="stime" type="radio" value="1" v-model="stime" @click="changePeriod('1')"/>
                开启　　
                <label class="timeLabel" v-show="stime=='1'">
                  <input name="classHour" class="put_num" type="text"  v-model="params.classHour" />
                  积分 <span class="text_12">完成后学员获得的积分奖励</span></label>
              </td>
            </tr>
            <tr>
              <td class="left_td">顺序学习：</td>
              <td>
                <input name="study" type="radio" value="0" v-model="params.isOrder"/>
                是　　　
                <input name="study" type="radio" value="1" v-model="params.isOrder"/>
                否</td>
            </tr>
            <tr>
              <td class="left_td">是否收费：</td>
              <td><input name="money" type="radio" value="1" v-model="money" @click="changePrice('1')"/>
                是　　　
                <input name="money" type="radio" value="0" v-model="money" @click="changePrice('0')"/>
                否　　
                <label class="moneyLabel" v-show="money=='1'">　
                  <input name="cost" type="text" class="put_num" v-model="params.cost" />
                  元</label>
              </td>
            </tr>
            <tr>
              <td class="left_td">推送平台：</td>
              <td><input name="platform" type="radio" value="1" v-model="params.platform"/>
                是　　　
                <input name="platform" type="radio" value="0" v-model="params.platform"/>
                否</td>
            </tr>
            <tr>
              <td class="left_td">直播状态：</td>
              <td><input name="class" type="radio" value="0" v-model="params.state"/>
                下架　　
                <input name="class" type="radio" value="1" v-model="params.state"/>
                上架</td>
            </tr>
          </table>
          <p class="btn_center">
            <input type="button" class="all_btn" value="提交完成" @click="editLivePlay('form')"/>
          </p>
        </form>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>

import UploadOSS from '@/components/common/upload/uploadOSS.vue'
import Ueditor from '@/components/common/UE/ue'
import teacherSelect from '@/page/byl/org/teacher/select.vue'
import ModalBox from '@/components/common/modal/index.vue'
import rangeManip from '@/components/byl/rangeManip/index.vue'
import utils from '@/utils'
import rangePermission from '@/utils/rangePermission'
import Bus from '@/utils/bus'
export default {
  components: { UploadOSS, Ueditor, teacherSelect },
  data () {
    return {
      rangePermission:  rangePermission,
      dat: {
        content: ''
      },
      ueditor: {
        value: '',
        config: {
          initialFrameWidth: 790,
          initialFrameHeight: 227
        }
      },
      params: {
        startTime: '',
        endTime: '',
        platform: '0',
        isOrder: '0',
        state: '0',
        visibleRange: '0',
        scope: '2',
        supplier: '1',
        livePlayAuthList: [],
        livePlayTeacherList: []
      },
      money: '0',
      stime: '0',
      currentTCIds: [],
      teacherList: [],
      publicStateList: [], // 推送范围人员列表
      scopeList: [], // 可见范围列表
      prefix: this.$route.meta.prefix || '',
      uploadOSSConf: { showMode: '1', style: 'img_upload2', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
    }
  },
  created () {
    if (this.$route.params.id === 'create') {
      this.params = {
        startTime: '',
        endTime: '',
        platform: '0',
        isOrder: '0',
        state: '0',
        visibleRange: '0',
        scope: '2',
        cost: '0',
        classHour: '0',
        supplier: '1',
        livePlayAuthList: [],
        livePlayTeacherList: []
      }
    } else {
      this.getLivePlay(this.$route.params.id).then((r) => {
        rangePermission.getRange(this.$route.params.id, '06', this.params.visibleRange).then((r) => {  // 获取推送范围
          this.publicStateList = r
        })
        // rangePermission.getScope(this.$route.params.id, '06', this.params.scope).then((r) => { // 获取可见范围
        //   this.scopeList = r
        // })
      })
    }
  },
  mounted () {
    this.getSTS()
    this.OSSUploadSuccess()
    this.initLayDate()
    Bus.$on('selectedTeachers', (data) => {
      this.currentTCIds = data
      this.getTeacherListByIds(this.currentTCIds)
    })
  },
  computed: {
    isEdit () {
      return this.$route.params.id && this.$route.params.id !== 'create'
    }
  },
  methods: {
    confirmBox (o) {
      var that = this
      this.$modal.show('dialog', {
        title: '提交',
        text: '确认提交吗？',
        buttons: [
          {
            title: '确认',
            default: false,
            handler: utils.debounce(() => {
              if (o.yes && o.yes instanceof Function) {
                o.yes()
                that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
              }
            }, 1000)
          },
          {
            title: '取消'
          }
        ]
      })
    },
    changePrice (val) {
      if (val == '0') {
        this.params.cost = '0'
      }
      this.money = val
    },
    changePeriod (val) {
      if (val == '0') {
        this.params.period = '0'
      }
      this.stime = val
    },
    returnContent () {
      this.dat.content = this.$refs.ue.getUEContent()
      return this.dat.content
    },
    setContent (str) {
      this.ueditor.value = this.$refs.ue.setUEContent(str)
    },
    OSSUploadSuccess (r) {
      if (r && r != '') {
        this.$set(this.params, r.dom_id, r.res.requestUrls[0])
      }
    },
    getLivePlay (id) {
      return new Promise((resolve, reject) => {
        this.$api.get(this.$global.livePlayApiPath, '/livePlayInfo/get', {id: id}, r => {
          resolve(r.data)
          this.params = r.data
          this.teacherList = this.params.livePlayTeacherList
          this.setContent(this.params.content)
          if (this.params.cost && this.params.cost != '0') {
            this.money = '1'
          } else {
            this.params.cost = '0'
            this.money = '0'
          }
          if (this.params.classHour && this.params.classHour != '0') {
            this.stime = '1'
          } else {
            this.params.classHour = '0'
            this.stime = '0'
          }
          if (this.params.livePlayTeacherList && this.params.livePlayTeacherList.length) {
            for (let i = 0; i<this.params.livePlayTeacherList.length; i++) {
              this.currentTCIds.push(this.params.livePlayTeacherList[i].teacherId)
            }
            this.getTeacherListByIds(this.currentTCIds)
          }
        })
      })
    },
    editLivePlay (scope) {
      var self = this
      this.$validator.validateAll(scope).then(function (result) {
        if (result) {
          self.confirmBox({
            yes: function () {
              self.params.content = self.returnContent()
              self.params.livePlayTeacherList = self.dealCurTCData(self.teacherList)
              self.$api.post(self.$global.livePlayApiPath, '/livePlayInfo/save', self.params, r => {
                if (self.$route.params.id == 'create') {
                  self.$toasted.show('直播创建成功！', {
                    duration: 1000
                  })
                  rangePermission.saveTo(r.data.id, '06', {type: self.params.visibleRange, value: self.publicStateList}, {type: self.params.scope, value: self.scopeList})
                  self.$router.push({path: self.prefix + '/org/livePlayList'})
                } else {
                  self.$toasted.show('直播修改成功！', {
                    duration: 1000
                  })
                  rangePermission.saveTo(self.params.id, '06', {type: self.params.visibleRange, value: self.publicStateList}, {type: self.params.scope, value: self.scopeList})
                  self.$router.push({path: self.prefix + '/org/livePlayList'})
                }
              })
            }
          })
        } else {
          self.$toasted.show('请确保信息正确与完整！', {
            duration: 800
          })
          return false
        }
      })
    },
    getSTS () {
      this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
        let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
        this.uploadOSSConf.STS = STS
      })
    },
    // teachers
    dealCurTCData (arr) {
      let teacherList = []
      if (arr && arr.length>0) {
        for (let i = 0; i<arr.length; i++) {
          let teacher = {
            teacherId: arr[i].id,
            teacherName: arr[i].name
          }
          teacherList.push(teacher)
        }
      }
      return teacherList
    },
    getTeacherListByIds (idsArr) {
      let idStr = ''
      if (idsArr && idsArr.length>0) {
        for (let i = 0; i<idsArr.length; i++) {
          if (i<idsArr.length-1) {
            idStr += idsArr[i] + ','
          } else if (i == idsArr.length-1) {
            idStr += idsArr[i]
          }
        }
      }
      this.$api.get(this.$global.teacherApiPath, '/teacher/batch', {ids: idStr}, r => {
        this.teacherList = r.data
      })
    },
    addTeacher (ids) {
      this.$modal.show(teacherSelect, {
        ids: ids
      })
    },
    delTSelectedId (ids, id) {
      for (let i = 0; i<ids.length; i++) {
        if (ids[i] === id) {
          ids.splice(i, 1);
        }
      }
      for (let i = 0; i<this.teacherList.length; i++) {
        if (this.teacherList[i].id === id) {
          this.teacherList.splice(i, 1)
        }
      }
    },
    initLayDate () {
      var self = this
      var startTime = laydate.render({
        elem: '#J-xl',
        type: 'datetime',
        done: function (value, date) {
          endTime.config.min ={
            year:date.year,
            month:date.month-1, //关键
            date: date.date,
            hours: 0,
            minutes: 0,
            seconds : 0
          };
          self.params.startTime=value;
        }
      });
      var endTime = laydate.render({
        elem: '#J-xl-2',
        type: 'datetime',
        done: function (value, date) {
          startTime.config.max={
            year:date.year,
            month:date.month-1, //关键
            date: date.date,
            hours: 0,
            minutes: 0,
            seconds : 0
          }
          self.params.endTime=value;
        }
      });
    },
    showRange () {
      var that = this
      this.$modal.show(ModalBox, {
        opts: {
          title: '设置推送范围',
          styles: {
            width: '960',
            height: String(0.8242 * window.screen.availHeight)
          },
          currentComponent: {
            name: 'range',
            template: rangeManip,
            outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
            inputs: that.publicStateList // 向组件内传入的数据, 一般用于初始化
          },
          yes (val) { // 点击确认后要做的事情
            that.publicStateList = val
          },
          closed () { // 这里要判断, 只有新增状态下需要清空
            if (that.$route.params.id == 'create') {
              that.publicStateList = []
            }
          }
        }
      })
    },
    showScope () {
      var that = this
      this.$modal.show(ModalBox, {
        opts: {
          title: '设置可见范围',
          styles: {
            width: '960',
            height: String(0.8242 * window.screen.availHeight)
          },
          currentComponent: {
            name: 'range',
            template: rangeManip,
            outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
            inputs: that.scopeList // 向组件内传入的数据, 一般用于初始化
          },
          yes (val) { // 点击确认后要做的事情
            that.scopeList = val
          },
          closed () { // 这里要判断, 只有新增状态下需要清空
            if (that.$route.params.id == 'create') {
              that.scopeList = []
            }
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/livePlay/model.vue